
import sourceVector from '../node_modules/ol/source/Vector.js';
import layerVector from '../node_modules/ol/layer/Vector.js';
// import StyleStyle from '../node_modules/ol/style/Style.js';
// import StyleFill from '../node_modules/ol/style/Fill.js';
// import StyleStroke from '../node_modules/ol/style/Stroke.js';
// import StyleCircle from '../node_modules/ol/style/Circle.js';
import GeoJSON from '../node_modules/ol/format/GeoJSON.js';
import Feature from '../node_modules/ol/Feature.js';
// these geometry constructors could go in an index.js and then: import * as olGeoms from 'geoms/index.js'
import Polygon from '../node_modules/ol/geom/Polygon.js';
import MultiPolygon from '../node_modules/ol/geom/MultiPolygon.js';
import Point from '../node_modules/ol/geom/Point.js';
import MultiPoint from '../node_modules/ol/geom/MultiPoint.js';

export default function(map) {
  let pidns;  // rwg.selection.ownership
  let vectorFeatures; // user drawn feature(s)
  let bufferLayerSource = new sourceVector();  // parcels within radius & buffer polygon

  if (rwg.config.defaultBufferDistance === undefined) {
    if (typeof rwg.defaultBufferDistance === 'number') {
      rwg.config.defaultBufferDistance = rwg.defaultBufferDistance;
      console.warn('defaultBufferDistance should be in rwg.config, not rwg');
      delete rwg.defaultBufferDistance;
    } else {
      rwg.config.defaultBufferDistance = 140;
    }
  }

  map.addLayer(new layerVector({
    title: 'lyrBuffer',
    source: bufferLayerSource,
    /*
    style:  new StyleStyle({
      stroke: new StyleStroke({
        color: 'rgba(255, 96, 0, 0.5)',
        width: 6
      }),
      image: new StyleCircle({
        radius: 5,
        fill: new StyleFill({
          color: 'rgba(255, 96, 0, 0.5)',
        })
      })
    }),
    */
    // this orange/rust style is applied to the parcels within the buffer
    // circle-* for point objects, stroke-* from polygon objects
    style: {  // object literal Style - definitions in node_modules/ol/style/flat.js
      "circle-radius": 5,
      "circle-fill-color": 'rgba(255, 96, 0, 0.5)',
      "circle-stroke-color": 'rgba(255, 96, 0, 0.5)',
      "stroke-color": 'rgba(255, 96, 0, 0.5)',
      "stroke-width": 6
    },
    zIndex: 6
  }));

  // this light blue style is applied to the buffer radius object
  rwg.styles.add('bufferStyle', {
    stroke: {
      color: 'rgba(85, 170, 255, 0.8)',
      width: 6
    }
  })

  function openDialog() {
    pidns = rwg.selection.ownership.getIdArray();
    // for Fremont County Idaho
    if (pidns.length === 0 && rwg.selection.ownass) {
      pidns = rwg.selection.ownass.getIdArray();
    }
    // for Fremont County Idaho
    if (pidns.length === 0 && rwg.selection.ownadj) {
      pidns = rwg.selection.ownadj.getIdArray();
    }
    vectorFeatures  = map.getLayerByTitle('lyrDraw').getSource().getFeatures();
    if ( !(pidns.length || vectorFeatures.length) ) {
      window.alert('Nothing to buffer.\nA parcel(s) must be selected or a polygon drawn.\nTo select a parcel(s) use the Info Tool or a search result.\nTo draw a polygon use the "Measure Areas" tool.');
      return;
    }
    if ( !rwg.filter && vectorFeatures.length > 1 ) {
      window.alert('Only one drawn feature can be buffered at a time\nbut there are ' + vectorFeatures.length + ' on the map.');
      return;
    }

    let content = document.getElementById('rwg-dialog-content');

    content.innerHTML = `
      <div style="width:25em; text-align:center">
        <form style="font-size: 1.5em;">Buffer Distance:
          <input type="text" value="${rwg.config.defaultBufferDistance}" size="5" class="w3-border w3-round"/>
          <hr>
          <button id="btn-buffer" style="margin-right: 15px;" class="rwg-btn">OK</button>
          <button id="btn-buffer-cancel" class="rwg-btn">Cancel</button>
        </form>
      </div>`
    // DO NOT set the style of the content div like below becasue it sticks and the next use of the content div will have that style.
    // content.style.width = '25em';
    // content.style.textAlign = 'center';
    document.getElementById('rwg-dialog').style.display = 'block';
    document.getElementById('btn-buffer').onclick = dialogCallback;
    // document.getElementById('btn-buffer-cancel').onclick = dailogCancel;
    document.getElementById('btn-buffer-cancel').onclick = (evt) => {
      console.log('in cancel')
      evt.preventDefault();
      document.getElementById('rwg-dialog-content').innerHTML = '';
      document.getElementById('rwg-dialog').style.display = 'none';
    }
  }

  function dialogCallback(evt) {
    evt.preventDefault();
    let formatGeoJSON;
    let payload = {
      buffer: this.form[0].value // evt.target.form[0].value
    };
    document.getElementById('rwg-dialog-content').innerHTML = '';
    document.getElementById('rwg-dialog').style.display = 'none';

    bufferLayerSource.clear();

    if (pidns.length) {
      payload.pidns = pidns.join().replace(/'/g, '');  // convert array to string and remove single quoting around each PIDN
    } else if (vectorFeatures.length === 1) { // currently only handling one vector feature
      formatGeoJSON = new GeoJSON();
      vectorFeatures.forEach(function(feature) {
        payload.geom = formatGeoJSON.writeGeometryObject(feature.getGeometry(), {decimals: 1});
      });
    } else {
      alert(`Can't buffer. No parcels are selected. ${vectorFeatures.length} drawn features. Can only buffer one drawn feature at a time.`);
      return;
    }

    fetch('listBufferJSON.php', {
      method: 'POST',
      contentType: 'application/json',
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(json => ajaxCallback(json))

  }

  function ajaxCallback(resultObj) {
    var
      infotoolDiv = document.querySelector('#infotool'),
      heading = document.createElement('div'),
      csvLink = document.createElement('a'),
      copyButton = document.createElement('button'),
      content, bufferGeom, bufferFeature,
      olGeoms = {
        MultiPolygon: MultiPolygon,
        Polygon: Polygon,
        Point: Point,
        MultiPoint: MultiPoint
      };
    // by making a new SelectionSet and putting it in rwg.selection it gets picked up by 'Copy to Clipboard'
    rwg.selection.adjoiners = new rwg.SelectionSet([
      [false], // row number, 'false' prevents it from being shown in the results list
      [''],[''],[''],
      [false, dat => {  // 'false' prevents entry being shown in info tool
        let geom = JSON.parse(dat);
        let feature = new Feature({
          geometry: new olGeoms[geom.type](geom.coordinates)
        });
        // if it's a point (or multi-point it doesn't have a style
        bufferLayerSource.addFeature(feature);
      }]
    ]);
    rwg.selection.adjoiners.update(resultObj.records);
    content = rwg.selection.adjoiners.render(null, resultObj.heading);   // (format, heading, footer)

    bufferGeom = JSON.parse(resultObj.buffer);
    bufferFeature = new Feature(
      new olGeoms[bufferGeom.type](bufferGeom.coordinates)
    );
    // bufferFeature.setStyle( new StyleStyle({
    //   stroke: new StyleStroke({
    //     color: 'rgba(85, 170, 255, 0.8)',
    //     width: 6
    //   })
    // }));
    bufferFeature.setStyle(rwg.styles.get('bufferStyle'))
    bufferLayerSource.addFeature(bufferFeature);

    // clear any existing content
    while(infotoolDiv.firstChild){
      infotoolDiv.removeChild(infotoolDiv.firstChild);
    }

    csvLink.innerText = 'Download CSV File';
    csvLink.style.margin = '1em';

    // var csvContent = 'data:text/csv;charset=utf-8,"Name","Address 1","Address 2"\n';
    let csvContent = '"Name","Address 1","Address 2"\n';
    let adjoiners = rwg.selection.adjoiners.selection;
    for(let row in adjoiners) {
      csvContent += '"' + adjoiners[row].slice(1,4).join('","') + '"\n';
    }
    /* https://stackoverflow.com/questions/4184944/javascript-download-data-to-file-from-content-within-the-page */
    let csvContentBlob = new Blob([csvContent], {'type':'text/csv'});
    csvLink.href = URL.createObjectURL(csvContentBlob);
    csvLink.setAttribute('download', 'buffer.csv');
    csvLink.setAttribute('type', 'text/csv');

    heading.appendChild(csvLink);

    copyButton.id = 'copy-button';
    copyButton.innerText = 'Copy to Clipboard';
    heading.appendChild(copyButton);

    infotoolDiv.appendChild(heading);
    infotoolDiv.appendChild(content);
    rwg.tabs.activate('side-info')

  }

  // switchboard
  return function(action) {
    if (action === 'buffer') {
      openDialog();
    } else if (action === 'clear') {
      bufferLayerSource.clear();
    }
  };

}
